var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { useTheme, keyframes } from 'styled-components';
import { useCronoSkeleton } from '../../Boost/CronoSkeleton';
import Label from '../Label/Label';
import Icon from '../../Styles/Icons/Icon';
import Box from '../../Layout/Flex/Box';
import Spinner from '../../Progress/Spinner/Spinner';
const InputStyleContainer = styled.div `
  position: relative;
  height: ${props => (props.fullHeight ? '100%' : 'auto')};
  width: ${props => props.width};
  height: ${props => props.height};
`;
const InputIconContainer = styled.div `
  position: relative;
  height: ${props => (props.fullHeight ? '100%' : 'auto')};
  width: 100%;
`;
const InputStyle = styled.input `
  position: relative;
  box-sizing: border-box;
  font-family: ${props => props.theme.fonts.fontFamily};
  width: inherit;
  height: ${props => (props.fullHeight ? '100%' : 'auto')};
  color: ${props => props.theme.utils.getColor(props.textColor)};
  background-color: white;
  border-radius: ${props => props.theme.borders.inputsBorderRadius};
  border-bottom-left-radius: ${props => props.dropdownContent ? '0' : props.theme.borders.inputsBorderRadius}; 
  border-bottom-right-radius: ${props => props.dropdownContent ? '0' : props.theme.borders.inputsBorderRadius}; 
  padding: ${props => props.theme.paddingsMargins.inputsPadding};
  padding-left: 1.8%;
  padding-right: 50px;
  border: 2px solid ${props => props.theme.utils.getColor(props.color)};
  transition: all 200ms ease-in-out;
  font-size: ${props => props.theme.utils.getSize(props.textSize)};
  &:focus {
    outline: none;
  }
  &::placeholder {
    opacity: 0.6;
    color: ${props => props.theme.colors.placeholderColor};
  }
`;
const Actions = styled.div `
  display: flex;
  cursor: ${props => props.value ? 'pointer' : 'not-allowed'};
  justify-content: center;
  align-items: center;
  border: ${props => props.theme.utils.getColor(props.color)};
  border-top-right-radius: ${props => props.theme.borders.inputsBorderRadius};  
  border-bottom-right-radius: ${props => props.dropdownContent ? '0' : props.theme.borders.inputsBorderRadius}; 
  background-color: ${props => props.theme.utils.getColor(props.color)};
  box-sizing: border-box;
  position: absolute;
  aria-hidden: true;
  height: 100%;
  width: 50px;
  top: 0rem;
  right: -0.1rem;
  transition: all 200ms ease-in-out;
  &>*{
     cursor: ${props => props.value ? 'pointer' : 'not-allowed'};
  }
`;
const fadeAnimation = keyframes `
  100% {
    opacity: 1;
  }
`;
const DropdownContainer = styled.div `
  opacity: 0;
  box-sizing: border-box;
  position: absolute;
  z-index: 9999;
  width: 100.2%;
  overflow-x: hidden;
  overflow-y: auto;
  height: ${props => props.dropdownHeight};
  padding: ${props => props.theme.paddingsMargins.themeMenuPadding};
  margin-top: ${props => `calc(${props.height} + 2px)`};
  background-color: #FFF;
  border: 2px solid ${props => props.theme.utils.getColor(props.color)};
  border-bottom-left-radius: ${props => props.theme.borders.inputsBorderRadius};  
  border-bottom-right-radius: ${props => props.theme.borders.inputsBorderRadius}; 
  animation: ${fadeAnimation} 200ms ease-in-out forwards;
`;
const SearchBar = (_a) => {
    var { onChange = () => { }, onClick, value, fullHeight = true, errors = {}, label, labelSize = 'article', isLoading = false, isLoadingLabel = false, placeholder = '', textSize = 'article', textColor = 'dark', type = 'text', isDisabled, noMargin = false, color = 'main', width = '100%', height = '40px', labelColor, skeleton, excludeMeFromLoadingContext = false, skeletonLabel, actionType = 'search', dropdownContent = undefined, dropdownHeight = 'auto' } = _a, props = __rest(_a, ["onChange", "onClick", "value", "fullHeight", "errors", "label", "labelSize", "isLoading", "isLoadingLabel", "placeholder", "textSize", "textColor", "type", "isDisabled", "noMargin", "color", "width", "height", "labelColor", "skeleton", "excludeMeFromLoadingContext", "skeletonLabel", "actionType", "dropdownContent", "dropdownHeight"]);
    const { loadingContext } = useCronoSkeleton();
    const theme = useTheme();
    const executeSearch = () => {
        if (onClick && !isLoading) {
            return (!value || isLoading ? () => { } : onClick());
        }
    };
    return (_jsxs(InputStyleContainer, Object.assign({}, props, { fullHeight: fullHeight, width: width, height: height }, { children: [!!label &&
                _jsx(Label, { isDisabled: isDisabled, label: label, labelSize: labelSize, color: labelColor || color, isLoading: isLoadingLabel && ((loadingContext && excludeMeFromLoadingContext === false) || isLoading), skeleton: skeletonLabel }), _jsxs(Box, Object.assign({ column: true, height: '100%', width: '100%' }, { children: [_jsxs(InputIconContainer, Object.assign({ fullHeight: fullHeight }, { children: [_jsx(InputStyle, { textColor: textColor, fullHeight: fullHeight, color: isDisabled ? theme.colors.placeholderColor : color, onChange: e => onChange(e), textSize: textSize, placeholder: placeholder, type: type, disabled: isDisabled, value: value, dropdownContent: dropdownContent, onKeyDown: (e) => {
                                    if (e.key === 'Enter') {
                                        executeSearch();
                                    }
                                } }), _jsx(Actions, Object.assign({ value: value, color: color, onClick: executeSearch, dropdownContent: dropdownContent }, { children: (loadingContext && excludeMeFromLoadingContext === false) || isLoading
                                    ? _jsx(Spinner, { width: '1.5rem', height: '1.5rem', secondary: color === 'main' })
                                    : _jsx(Icon, { icon: actionType, color: 'white', size: textSize }) }))] })), dropdownContent &&
                        _jsx(DropdownContainer, Object.assign({ color: color, height: height, dropdownHeight: dropdownHeight }, { children: dropdownContent }))] }))] })));
};
export default SearchBar;
